module.exports = __webpack_public_path__ + "static/media/cert_142.d51c0a78.jpg";